module.exports = __webpack_public_path__ + "static/media/change-password-ico.6ece9ed7.png";